import { AirbnbReservationState } from './airbnb-reservation.interfaces';

export const initialState = {} as AirbnbReservationState;
